module.exports = __webpack_public_path__ + "img/95.d399f71e.jpg";